import React from 'react';
import FormSection from '../../../../components/atom/FormSection';
import FormikInput from '../../../../components/atom/FormikInput';

const ClientEditGoogleAnalytics = () => {
    return (
        <FormSection title="Google Analytics integration">
            <FormikInput name="gaTrackingId" label="GA Measurement ID" />
        </FormSection>
    );
};

export default ClientEditGoogleAnalytics;
